import { BaseModel } from '../../../../../../core/_base/crud'

export class HangHoaModel extends BaseModel {
	IdHh: number
	IdPO: number
	IdKho: number
	MaPO: string
	TenHH: string
	MaHH: string
	QuyCach: string
	Dvt: number
	TenDVT: string
	Soluongphanmem: string
	Solo: string
	IdNcc: number
	TenNCC: string
	MaNCC: string
	Ngaysanxuat: string
	Handung: string
	IdTs: number
	Sopo: string
	IdLo: number
	SoMay: string
	MaSub: string
	NgayNhap: string
	ChoPhepXuatKho: boolean

	clear() {
		this.IdHh = 0;
		this.IdPO = 0;
		this.IdKho = 0;
		this.MaPO = ''
		this.TenHH = '';
		this.MaHH = '';
		this.QuyCach = '';
		this.Dvt = 0;
		this.TenDVT = '';
		this.Solo = '';
		this.IdNcc = 0;
		this.TenNCC = '';
		this.MaNCC = '';
		this.Ngaysanxuat = '';
		this.Handung = '';
		this.IdTs = 0;
		this.Sopo = '';
		this.IdLo = 0;
		this.SoMay = "";
		this.MaSub = "";
		this.NgayNhap = "";
		this.ChoPhepXuatKho = false;
	}
	copy(item: HangHoaModel) {
		this.IdHh = item.IdHh;
		this.IdPO = item.IdPO;
		this.IdKho = item.IdKho;
		this.MaPO = item.MaPO;
		this.TenHH = item.TenHH;
		this.MaHH = item.MaHH;
		this.QuyCach = item.QuyCach;
		this.Dvt = item.Dvt;
		this.TenDVT = item.TenDVT;
		this.Solo = item.Solo;
		this.IdNcc = item.IdNcc;
		this.TenNCC = item.TenNCC;
		this.MaNCC = item.MaNCC;
		this.Ngaysanxuat = item.Ngaysanxuat;
		this.Handung = item.Handung;
		this.IdTs = item.IdTs;
		this.Sopo = item.Sopo;
		this.IdLo = item.IdLo;
		this.SoMay = item.SoMay;
		this.MaSub = item.MaSub;
		this.NgayNhap = item.NgayNhap;
		this.ChoPhepXuatKho = item.ChoPhepXuatKho;
	}
}
